import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, SCREEN_BOTTOM_PADDING, SettingsItem, SettingsSection, Spacer, withAnimatedNavigationHeader, } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { IconJudge } from 'design-system/icons/IconJudge';
import { IconClipboard } from 'design-system/icons/IconClipboard';
import { IconForbidden } from 'design-system/icons/IconForbidden';
import { isWeb } from '../../../constants';
const strings = {
    headerTitle: 'Rulings and judgments',
    insolvencies: 'Bankruptcies and Insolvencies',
    judgments: 'Court Judgments',
    cifas: 'Cifas',
};
const CreditReportRulingsScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, [navigation]);
    const handlePress = useCallback((type) => {
        navigation.navigate('CreditReportRulingDetailScreen', {
            type,
        });
    }, [navigation]);
    return (<AppView withFrame={false}>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} showsVerticalScrollIndicator contentContainerStyle={contentContainerStyle}>
            <Spacer.H8 />
            <SettingsSection noMarginTop>
              <SettingsItem title={strings.insolvencies} icon={<IconForbidden gradientKey="peach"/>} onPress={() => handlePress('insolvency')}/>
              <SettingsItem title={strings.judgments} icon={<IconJudge alt gradientKey="darkPink"/>} onPress={() => handlePress('judgment')}/>
              <SettingsItem title={strings.cifas} icon={<IconClipboard alt gradientKey="darkPurple"/>} onPress={() => handlePress('cfasCases')}/>
            </SettingsSection>
          </Animated.ScrollView>
        </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default CreditReportRulingsScreen;
